import { useQuery } from "@tanstack/react-query";
import { getAllCategories } from "../../api/apiCategories";
import i18next from "i18next";

const useGetCategories = (page = 1, perPage = 15, filters = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["categories", page, perPage, filters, i18next.language],
        queryFn: () => getAllCategories(page, perPage, filters),
    });

    return {
        categories: data?.data || {},
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch,
    };
};

export default useGetCategories;
